module.exports = __webpack_public_path__ + "981c84b351beb5b97de692269d8a6c70.jpg";